import { GNS } from './GNS.js';

/**
 * GNS.Globals
 * 
 * アプリケーション全体の設定値を管理
 * 
 * プロパティ:
 * - VERSION: バージョン番号
 * - REDIRECT: リダイレクト有効フラグ
 * - DEBUG: デバッグモード
 * - ROOT: ルートパス
 * - isLocal: ローカル環境判定
 */
GNS.Globals = function (a) {
    var b = a.create();
    return b._static.VERSION = "1_0_0", b._static.REDIRECT = !0, b._static.DEBUG = !1, b._static.ROOT = "./", b.jsSP = !
        1, b._static.isLocal = -1 != String(window.location.protocol)
            .indexOf("file"), b._self
}(GNS);
